import { render, staticRenderFns } from "./modelHiq.vue?vue&type=template&id=f8521438&scoped=true&"
import script from "./modelHiq.vue?vue&type=script&lang=js&"
export * from "./modelHiq.vue?vue&type=script&lang=js&"
import style0 from "./modelHiq.vue?vue&type=style&index=0&id=f8521438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8521438",
  null
  
)

export default component.exports